<script>
  let {
    rowClass = null,
    keyClass = null,
    valueClass = null,
    extraRowClass = '',
    extraKeyClass = '',
    extraValueClass = '',
    key,
    value
  } = $props()

  const defaults = {
    row: 'd-grid gap-3 py-4',
    key: 'p-0',
    value: 'p-0'
  }

  const computedRowClass = $derived(
    rowClass !== null
      ? rowClass
      : [defaults.row, extraRowClass].filter(Boolean).join(' ')
  )

  const computedKeyClass = $derived(
    keyClass !== null
      ? keyClass
      : [defaults.key, extraKeyClass].filter(Boolean).join(' ')
  )

  const computedValueClass = $derived(
    valueClass !== null
      ? valueClass
      : [defaults.value, extraValueClass].filter(Boolean).join(' ')
  )
</script>

<div class={computedRowClass}>
  <div class={computedKeyClass}>
    {@render key()}
  </div>

  <div class={computedValueClass}>
    {@render value()}
  </div>
</div>
